import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
@Injectable({
	providedIn: "root"
})
export class Safe2Go {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	login(payload) {
		return this.http.post<any>(`${environment.urlApi}/Safe2Go/IntegracaoLogin`, payload);
	}
}
